module.exports = __webpack_public_path__ + "static/media/TeresaSchiratti.078804b1.jpg";